// Body load opacity
$(window).on("load",(function(){ 
	$("body").animate({opacity:1},700);  
setTimeout(function(){     
    $(".slide-up").addClass('active'); 
}, 300);

setTimeout(function(){     
    $(".mega-menu_contents").css('display', 'block'); 
}, 500)

setTimeout(function(){     
    $("body").css('overflow', 'inherit'); 
}, 500)

setTimeout(function(){     
   $("#stone-wrap .stone-box:first-child input").trigger('click'); 
}, 1000);

if ($(window).width() < 767) {
  setTimeout(function(){     
    $('.related-products .product-grid').slick({
    dots: true,
    infinite: true,
    arrows:false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1 
    }); 
  }, 1000);
}

  
  
}));



$(document).ready(function() {

$(document).on("click",".cpb-option.cpb-option-type-img",function() {
        //alert("click bound to document listening for #test-element");
        $(".jNJIeB span").show();
    });
  
  
  $(".footer-block--menu a[href='#']").attr('href', 'javascript:void(0)'); 

  
  // Home page Just In section slider
$('.featured-slider').slick({
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

if ($(window).width() < 767) {
  
$('.home_products-row').slick({
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1 
});

 $('.slider--mobiles').slick({
  dots: true,
  infinite: true,
   arrows:false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1 
}); 

  setTimeout(function(){     
$('.related-products .product-grid').slick({
  dots: true,
  infinite: true,
   arrows:false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1 
}); 
    }, 1500);
  
} else {

  // press single page product move
$( ".press-article-page .related-products, .returen_press" ).insertAfter( ".article-content .rte" );
}

  
  // Bespokeimg page image slider
  $('.bespoke-slider').slick({
  dots: false,
  arrows:true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
});
    
  // Home page Collections slider
/*
 var swiper = new Swiper(".mySwiper", {
	  slidesPerView: 1.5,
      spaceBetween: 10, 
      loopedSlides: 2,
      loop: false,
      freeMode: true,
      mousewheel: {
      releaseOnEdges: true,
      },
    breakpoints: {  
    '767': {
      slidesPerView: 3,
      spaceBetween: 30,
    },
     '989': {
      slidesPerView: 3,
      spaceBetween: 26,      
    },
  },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      }
    });

*/


  

// Newsletter 
 $('#top-mc-form').ajaxChimp({
    url: '//aureliademark.us17.list-manage.com/subscribe/post?u=7ad2a716576243661cd68e743&amp;id=589256cdfc'
   //   url: '//aureliademark.us17.list-manage.com/subscribe/post?u=7ad2a716576243661cd68e743&amp;id=589256cdfc'
  });
   $('#inline-form').ajaxChimp({
     url: '//aureliademark.us17.list-manage.com/subscribe/post?u=7ad2a716576243661cd68e743&amp;id=589256cdfc'	
    //   url: '//aureliademark.us17.list-manage.com/subscribe/post?u=7ad2a716576243661cd68e743&amp;id=589256cdfc' 
  });
  $('#popup-mc-form').ajaxChimp({
     url: '//aureliademark.us17.list-manage.com/subscribe/post?u=7ad2a716576243661cd68e743&amp;id=589256cdfc',
    // url: '//aureliademark.us17.list-manage.com/subscribe/post?u=7ad2a716576243661cd68e743&amp;id=589256cdfc',
    callback: callbackFunction
  });
function callbackFunction (resp) {
    if (resp.result === 'success') {
      setTimeout(function(){     
		  $("#shopify-section-site_newsletter").fadeOut(); 
		  }, 1000);
    }
}



  
});


//cookie code
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}      
function _fnaccept() {
    setCookie('isvisited','yes',30);
    setCookie('isvisitedpopup','yes',30);
    $("#shopify-section-cookies").fadeOut();
	$("#shopify-section-site_newsletter").fadeOut();
  
}      
function getCookie(cname) {
var name = cname + "=";
var ca = document.cookie.split(';');
for(var i=0; i<ca.length; i++) {
   var c = ca[i];
   while (c.charAt(0)==' ') c = c.substring(1);
   if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
}
  return "";
}
 $(function(){
      var isvisited = getCookie("isvisited");
      var isvisitedpopup = getCookie("isvisitedpopup");      
      if (isvisited == null || isvisited=='')  {
        $(window).on('load', function() {
          setTimeout(function(){     
          $("#shopify-section-cookies").fadeIn(); 
             }, 2000);
		  setTimeout(function(){     
		  $("#shopify-section-site_newsletter").fadeIn(); 
		  }, 7000);
        });
      }   
      $(".cookie_accept").click(function() {
        setCookie('isvisited','yes', 30);
        $("#shopify-section-cookies").fadeOut();
      });  
	  
	  $(".close_popup, .popup_overlay").click(function() {
        setCookie('isvisited','yes', 30);
        $("#shopify-section-site_newsletter").fadeOut();
      });
});
//end cookie 



// FAQ page accordion jquery
$('body').on('click', '.faq-box h4', function() {
	$('.faq-box').find('.faq-rte').stop().slideUp('fast');
	$(this).closest('.faq-box').find('.faq-rte').stop().slideToggle('fast');  	
	$('.faq-box h4').not(this).removeClass('active');
	$(this).toggleClass('active');  
});






 $(document).ready( function(){

$(".drop_imge-0").insertAfter("#all_submenu > .mega-menu__list");
$(".drop_imge-1").insertAfter("#pendants_submenu > .mega-menu__list");  
$(".drop_imge-2").insertAfter("#necklaces_submenu > .mega-menu__list");
$(".drop_imge-3").insertAfter("#bracelets_submenu > .mega-menu__list");  
$(".drop_imge-4").insertAfter("#rings_submenu > .mega-menu__list"); 
$(".drop_imge-5").insertAfter("#earrings_submenu > .mega-menu__list");  


/*
  $(".drop_imge-0").insertAfter("#HeaderMenus-all-shop-by-collection + div .list-unstyled");
   $(".drop_imge-1").insertAfter("#HeaderMenus-necklaces-shop-by-collection + div .list-unstyled");
  // $(".drop_imge-1").insertAfter("#HeaderMenus-pendants-shop-by-collection + div .list-unstyled");
  $(".drop_imge-2").insertAfter("#HeaderMenus-bracelets-shop-by-price + div .list-unstyled");
  $(".drop_imge-3").insertAfter("#HeaderMenus-rings-shop-by-price + div .list-unstyled");
  $(".drop_imge-4").insertAfter("#HeaderMenus-earrings-shop-by-price + div .list-unstyled");
  */
   
//     $('#customer_register_link').click( function(event){
//     	event.preventDefault();
//       	$('.registration-form-wrapper').toggleClass('colapsed');
        
//       	if( !$('.registration-form-wrapper').hasClass('colapsed') ) {
// 			$('.password-input-box').hide();
//           	$('.email-address-input-box').hide();
//           	$('.login-btton-input-box').hide();
//           	$('.login-email-error').addClass('hide');
//           	$('.login-password-error').addClass('hide');
//         } else {
//         	$('.password-input-box').show();
//           	$('.email-address-input-box').show();
//           	$('.login-btton-input-box').show();
//         }
//     } );
    
//     $('.LoginHeading').click( function(event){
//       $('.registration-form-wrapper').addClass('colapsed');
//       $('.password-input-box').show();
//       $('.email-address-input-box').show();
//       $('.login-btton-input-box').show();
//     });
    
    $('#CustomerEmail, #CustomerPassword').keypress(function (e) {
      if (e.which == 13) {
        onSubmitLogin();
        return false;    //<---- Add this line
      }
    });
    
    $.fx.speeds.slow = 2000;
    
//     	$('#login-section-wrapper').fadeIn('slow');
    	$('#login-section-wrapper').show();
      	$('#create-section-wrapper').hide();
      	$('#RecoverPasswordForm').hide();
      	$('.login-lable').hide();
        $('.create-about-lable').show();
        $('.forgot-password-lable').show();
    
    function hideErrors () {
    	$('.login-email-error').addClass('hide');
  		$('.login-password-error').addClass('hide');
    }
    
	// login side bar code
    $('.login-lable').click(function(){
    	$('#login-section-wrapper').show();
      	$('#create-section-wrapper').hide();
      	$('#RecoverPasswordForm').hide();
      	$('.login-lable').hide();
        $('.create-about-lable').show();
        $('.forgot-password-lable').show();
      	hideErrors();
    });
    
    
    $('.create-about-lable').click( function(){
      	$('#create-section-wrapper').show();
    	$('#login-section-wrapper').hide();
      	$('#RecoverPasswordForm').hide();
      	$('.login-lable').show();
        $('.create-about-lable').hide();
        $('.forgot-password-lable').show();
      	hideErrors();
    } );
    
	$('.forgot-password-lable').click( function(){
      	$('#RecoverPasswordForm').show();
    	$('#login-section-wrapper').hide();
      	$('#create-section-wrapper').hide();
      	$('.login-lable').show();
        $('.create-about-lable').show();
        $('.forgot-password-lable').hide();
      	hideErrors();
    } );
    
    $('#cancel-forget-password').click( function(){
      	$('#login-section-wrapper').show();
    	$('#RecoverPasswordForm').hide();
      	$('#create-section-wrapper').hide();
      
      	$('.login-lable').hide();
        $('.create-about-lable').show();
        $('.forgot-password-lable').show();
      	hideErrors();
    });

    
  });
  function validateLoginForm() {
    var userEmail = $('#CustomerEmail').val();
    var userPassword = $('#CustomerPassword').val();
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    var valid = true;

    if(!pattern.test(userEmail))
    {
      $('#CustomerEmail').addClass('error');
      valid = false;
      $('.login-email-error').removeClass('hide');
    } else {
      $('#CustomerEmail').removeClass('error');
      $('.login-email-error').addClass('hide');
    }
    
    if(userPassword.trim().length < 6)
    {
      $('#CustomerPassword').addClass('error');
      valid = false;
      $('.login-password-error').removeClass('hide');
    } else {
      $('#CustomerPassword').removeClass('error');
      $('.login-password-error').addClass('hide');
    }
    return valid;
  }
  
  function validateRegisterForm() {
    var userEmail = $('#RegisterForm #-email').val();
    var userPassword = $('#RegisterForm #-password').val();
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    var valid = true;

    if(!pattern.test(userEmail))
    {
      $('#RegisterForm #-email').addClass('error');
      valid = false;
      $('.login-email-error').removeClass('hide');
    } else {
      $('#RegisterForm #-email').removeClass('error');
      $('.login-email-error').addClass('hide');
    }
    
    if(userPassword.trim().length < 6)
    {
      $('#RegisterForm #-password').addClass('error');
      valid = false;
      $('.login-password-error').removeClass('hide');
    } else {
      $('#RegisterForm #-password').removeClass('error');
      $('.login-password-error').addClass('hide');
    }
    return valid;
  }
  
  function validatePasswordRecoverForm() {
    var userEmail = $('#RecoverEmail').val();
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    var valid = true;

    if(!pattern.test(userEmail))
    {
      $('#RecoverEmail').addClass('error');
      valid = false;
      $('.login-email-error').removeClass('hide');
    } else {
      $('#RecoverEmail').removeClass('error');
      $('.login-email-error').addClass('hide');
    }
    
    return valid;
  }
  
  function onSubmitLogin(){
    if( validateLoginForm() ) {
    	$('#customer_login').submit();
    }
  }
  
  function onSubmitRegister(){
    if( validateRegisterForm() ) {
    	$('#RegisterForm').submit();
    }
  }
  
  function onSubmitPasswordRecover(){
    if( validatePasswordRecoverForm() ) {
    	$('#RecoverPasswordForm form').submit();
    }
  }


 $('.header__icon--account, .mo_accountlink').on('click', function () {
    $('.login-box').toggleClass('active-box');
    $('.login-hover').fadeIn();
  });
$('.login-hover, .cls_p').on('click', function () {
    $('.login-box').removeClass('active-box');
    $('.login-hover').fadeOut();
  });



 (function() { 
     var REDIRECT_PATH = '/account'; 
   
     var selector = '#create_customer, form[action$="/account"][method="post"]', 
         $form = document.querySelectorAll(selector)[0]; 
   
     if ($form) { 
       $redirect = document.createElement('input'); 
       $redirect.setAttribute('name', 'return_to'); 
       $redirect.setAttribute('type', 'hidden'); 
       $redirect.value = REDIRECT_PATH; 
       $form.appendChild($redirect);  
     } 
   })();



/*
$('body').on('click', '.gf-option-box button', function() {  
  alert('1');
  setTimeout(function(){
    alert('2');
    //$(this).parent().parent().parent().parent().parent().find(".gf-block-title h3").click();
    $(document).click();
  }, 500);
});
*/


$('body').on('click', '.gf-option-block:nth-child(1) .gf-block-title .h3', function() {
/*
  $('#gf-tree').addClass('gf_active');

  
  $('#gf-tree').toggleClass('gf_active_1');
  $('#gf-tree').removeClass('gf_active_2');
  $('#gf-tree').removeClass('gf_active_3');
  $('#gf-tree').removeClass('gf_active_4');
  $('#gf-tree').removeClass('gf_active_5');*/

    //e.stopPropagation(); // This is the preferred method.
    //return false;
});



/*
$('body').on('click', '.gf-option-block:nth-child(2) .gf-block-title .h3', function() {
    $('#gf-tree').removeClass('gf_active_1');
  $('#gf-tree').toggleClass('gf_active_2');
  $('#gf-tree').removeClass('gf_active_3');
  $('#gf-tree').removeClass('gf_active_4');
  $('#gf-tree').removeClass('gf_active_5');

  ///e.stopPropagation(); // This is the preferred method.
    //return false;
});


$('body').on('click', '.gf-option-block:nth-child(3) .gf-block-title .h3', function() {
     $('#gf-tree').removeClass('gf_active_1');
  $('#gf-tree').removeClass('gf_active_2');
  $('#gf-tree').toggleClass('gf_active_3');
  $('#gf-tree').removeClass('gf_active_4');
  $('#gf-tree').removeClass('gf_active_5');
});
$('body').on('click', '.gf-option-block:nth-child(4) .gf-block-title .h3', function() {
   $('#gf-tree').removeClass('gf_active_1');
  $('#gf-tree').removeClass('gf_active_2');
  $('#gf-tree').removeClass('gf_active_3');
  $('#gf-tree').toggleClass('gf_active_4');
  $('#gf-tree').removeClass('gf_active_5');
});
$('body').on('click', '.gf-option-block:nth-child(5) .gf-block-title .h3', function() {
  $('#gf-tree').removeClass('gf_active_1');
  $('#gf-tree').removeClass('gf_active_2');
  $('#gf-tree').removeClass('gf_active_3');
  $('#gf-tree').removeClass('gf_active_4');
  $('#gf-tree').toggleClass('gf_active_5');
});

$('body').on('click', '#gf-tree button', function() {
  $('#gf-tree').removeClass('gf_active_1');
  $('#gf-tree').removeClass('gf_active_2');
  $('#gf-tree').removeClass('gf_active_3');
  $('#gf-tree').removeClass('gf_active_4');
  $('#gf-tree').removeClass('gf_active_5');  
});


*/


$(window).on("load resize",function(){
   setTimeout(function(){     		 
    var navimgwidth = $('.drop_imge-1').width();	
    $(".drop_imge-0").css('max-width', navimgwidth);
      }, 1000);
});



$(".collection-hero__title").html(function(){
  var text= $(this).text().trim().split(" ");
  var first = text.shift();
  return (text.length > 0 ? "<span>"+ first + "</span> " : first) + text.join(" ");
});





